import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type {
  TrashItem,
  TrashRestoreResponse,
  TrashDeleteResponse,
  TrashTableListResponse,
} from '@/modules/Configuracion/interfaces/IPapelera'

export class TrashService extends BaseService<TrashItem> {
  constructor () {
    super({
      baseUrl: 'system/trash/'
    })
  }

  async generales(): Promise<AxiosResponse<TrashTableListResponse>> {
    return this.http.get<TrashTableListResponse>(`/general`)
  }
  async restore(tabla: string, key: string, value: string | number): Promise<AxiosResponse<TrashRestoreResponse>> {
    return this.http.put<TrashRestoreResponse>(
      `/restore?table=${tabla}&field=${key}&value=${value}`
    )
  }

  async deleteTrash(tabla: string, key: string, value: string | number): Promise<AxiosResponse<TrashDeleteResponse>> {
    return this.http.delete<TrashDeleteResponse>(
      `/destroy?table=${tabla}&field=${key}&value=${value}`
    )
  }

  async deleteAllTrash(tabla: string): Promise<AxiosResponse<TrashDeleteResponse>> {
    return this.http.delete<TrashDeleteResponse>(
      `/destroy-all?table=${tabla}`
    )
  }
}
